module.exports = __webpack_public_path__ + "static/media/heinrichsdoerferweg_strasse.fdbf14f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/projekte/heinrichsdoerferweg_strasse.jpg
// module id = 355
// module chunks = 0